/* Pure Limitless long-form kit (spec 14, section 3.11). Vanilla, no
   dependencies, loaded with defer. Scroll position is only ever read through
   IntersectionObserver: no scroll or wheel listeners. */
(function () {
  var d = document, h = d.documentElement,
    motion = !matchMedia('(prefers-reduced-motion: reduce)').matches,
    hasIO = 'IntersectionObserver' in window;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function io(f, o) { return new IntersectionObserver(f, o); }

  // 1. Sticky buy bar. Functional, so it runs with reduced motion too.
  var bar = q('[data-pl-sticky]'), atc = q('[data-pl-atc="main"]'), stop = q('[data-pl-sticky-stop]');
  if (bar && atc && hasIO) {
    var past = false, atEnd = false, blocked = false;
    var update = function () {
      var show = past && !atEnd && !blocked;
      bar.classList.toggle('is-shown', show);
      bar.toggleAttribute('inert', !show);
      h.classList.toggle('lf-bar-on', show);
    };
    // Shown only once the main button has left the viewport at the top.
    // The root is extended far below the viewport, so "not intersecting"
    // means "above the viewport", and a jump (anchor, End key) from below
    // the button to above it still counts as a change and fires.
    io(function (es) {
      es.forEach(function (e) { past = !e.isIntersecting; });
      update();
    }, { threshold: 0, rootMargin: '0px 0px 99999px 0px' }).observe(atc);
    if (stop) io(function (es) {
      es.forEach(function (e) { atEnd = e.isIntersecting; });
      update();
    }, { threshold: 0 }).observe(stop);
    // Never cover the cart drawer or a dialog (snippets/header-icon.liquid, assets/main.js).
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-bs-toggle="modal"],.shopping-cart a.cart-count')) { blocked = true; update(); }
      else if (t.closest('.shopping-cart-close,.mm-fullscreen-bg')) { blocked = false; update(); }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      setTimeout(function () { blocked = !!q('.mini-cart.show,.modal.show'); update(); }, 350);
    });
  }

  // Reduced motion or no observer: everything stays visible and static.
  if (!motion || !hasIO) return;

  // 2. Shared reveal observer. Hidden start states begin only when
  // html.lf-motion is set, after the first callback has marked everything
  // already in view (or scrolled past) as shown without a transition. The
  // root is extended far above the viewport, so anything above it counts
  // as in view: content jumped over by an anchor link is never left hidden.
  var targets = qa('[data-pl-reveal],[data-pl-stagger],[data-pl-mask],[data-pl-numeral]'), first = true;
  var rev = io(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        if (first) e.target.classList.add('is-instant');
        e.target.classList.add('is-in');
        rev.unobserve(e.target);
      }
    });
    if (first) {
      first = false;
      h.classList.add('lf-motion');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          qa('.is-instant').forEach(function (x) { x.classList.remove('is-instant'); });
        });
      });
    }
  }, { threshold: 0, rootMargin: '99999px 0px -12% 0px' });
  if (targets.length) targets.forEach(function (t) { rev.observe(t); });
  else h.classList.add('lf-motion');

  // 3. Pinned steps: the step crossing the middle of the viewport is active.
  qa('[data-pl-pin]').forEach(function (pin) {
    var steps = qa('[data-pl-step]', pin);
    var o = io(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        steps.forEach(function (s) { s.classList.toggle('is-active', s === e.target); });
        pin.setAttribute('data-pl-active', e.target.getAttribute('data-pl-step'));
      });
    }, { threshold: 0, rootMargin: '-50% 0px -50% 0px' });
    steps.forEach(function (s) { o.observe(s); });
  });

  // 4. Marquee: wire the Pause button, then let the CSS loop start.
  qa('[data-pl-marquee]').forEach(function (m) {
    var b = q('[data-pl-marquee-toggle]', m);
    if (!b) return;
    var l = q('.lf-marquee__label', b);
    b.hidden = false;
    b.addEventListener('click', function () {
      var p = m.classList.toggle('is-paused');
      l.textContent = b.getAttribute(p ? 'data-pl-play-label' : 'data-pl-pause-label') || (p ? 'Play' : 'Pause');
    });
    m.classList.add('is-ready');
  });
})();
